import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseTrackDetailsProps {
  trackId: string;
  /** Off while the caller has no track yet, so no read goes out for an empty id. */
  enabled?: boolean;
}

export const useTrackDetails = ({ trackId, enabled = true }: UseTrackDetailsProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  const trackDetailsQuery = useTRPCQuery({
    ...trpcMusicAPI.tracks.details.queryOptions({
      trackId,
      ...shareTokenInput,
    }),
    enabled,
  });

  return trackDetailsQuery;
};
